import { useInterval } from '@montugroup/circuit-shared/hooks/useInterval';
import { useCallback, useRef, useState } from 'react';

/**
 * Runs an invitation cooldown using elapsed time and cleans up its interval on unmount.
 * @param durationSeconds - The minimum time between requests.
 * @returns The remaining seconds and a function to start the cooldown.
 */
export function useResendInviteCountdown(durationSeconds: number) {
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const unlockAt = useRef(0);

  const startCountdown = useCallback(() => {
    const durationMs = durationSeconds * 1000;
    unlockAt.current = Date.now() + durationMs;
    setSecondsRemaining(durationSeconds);
  }, [durationSeconds]);

  useInterval(
    () => setSecondsRemaining(Math.max(0, Math.ceil((unlockAt.current - Date.now()) / 1000))),
    secondsRemaining > 0 ? 1000 : null,
  );

  return { secondsRemaining, startCountdown };
}
